export default {
  userId(state) {
    return state.userId;
  },
  token(state) {
    return state.token;
  },
  isAuthenticated(state) {
    return !!state.token;
  },
  userType(state) {
    return state.userType;
  },
  didAutoLogout(state) {
    return state.didAutoLogout;
  },
  getUser(state) {
    return state.userId;
  },
};
